import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Chat from '../features/chat/components/Chat';
import Privacy from '../pages/SubPage/Privacy';
import GettingStarted from '../pages/SubPage/HowToUseVandri';
import MeetVandri from '../pages/SubPage/AboutVandri';
import Sources from '../pages/SubPage/Sources';
import NotFound from '../pages/SubPage/NotFound';
import MenuPage from '../pages/Menu/MenuPage';

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route exact path="/" element={<Chat />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/getting-started" element={<GettingStarted />} />
        <Route path="/about-vandri" element={<MeetVandri />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="*" element={<NotFound />} /> 
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes; 